import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { AuthenticationServices } from "../services/authentication.services";

@Directive({ selector: '[infobox]' })

export class InfoboxDirective {

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private activeUser: AuthenticationServices
    ){}

    @Input() set infobox( document: any ){

        if( document ) {

          const { image, video, meta, location } = document;
          const { event, names, keywords, occasion, venue } = meta;
          const { city, country, state } = location;

          let thisNames: string, thisEvent: string, thisKeywords: any, thisOccasion: string, thisVenue: string;

          if ( keywords && keywords.length > 0 ) {
            thisKeywords = keywords.map( ( keyword: string ) => keyword = ` ${keyword}`);
          }

          if ( occasion ) thisOccasion = `enjoying ${ occasion }`;

          if ( event ) {
            this.activeUser.language === 'english' ?
              thisEvent = event['en'] :
              thisEvent = event['da'] ;
          }

          if ( venue ) thisVenue = ` @ ${ venue }`;

          if ( names && names.length > 0 ) {
            names.forEach( ( name: string, index: number ) => {
              if ( name ) {
                const isFirstIndex = ( index === 0 );
                const isLastIndex = ( index === names.length - 1 );
                if ( isFirstIndex ) thisNames = name;
                if ( isLastIndex && !isFirstIndex ) thisNames += ` and ${name}`;
                if ( !isFirstIndex && !isLastIndex ) thisNames += `, ${name}`;
              }
            });
          }

          if ( image ) {
            let where: string[] = [];

            city ? where.push( city ) : null ;
            (country && country === 'United States') ? where.push(state) : where.push(country);

            where = where.map( ( item: string ) => item = ` ${ item }`);

            document['where'] = where.toString();

          }

          document['who'] = ( thisNames && thisNames.length > 0 ) ? thisNames: null;
          document['search'] = ( thisKeywords && thisKeywords.length > 0 ) ? thisKeywords : null ;

          document['what'] =
            ( thisEvent || thisOccasion ) ?
              thisVenue ?
                ( thisEvent || thisOccasion ) + thisVenue :
                ( thisEvent || thisOccasion ) :
              thisVenue ?
                thisVenue :
                '';

          this.viewContainer.createEmbeddedView(this.templateRef);

        }

        else {
          this.viewContainer.clear();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/directives/infobox.directive.ts